import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::index
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:20
* @route '/hero-banners'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/hero-banners',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::index
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:20
* @route '/hero-banners'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::index
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:20
* @route '/hero-banners'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::index
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:20
* @route '/hero-banners'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::index
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:20
* @route '/hero-banners'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::index
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:20
* @route '/hero-banners'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::index
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:20
* @route '/hero-banners'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::create
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:36
* @route '/hero-banners/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/hero-banners/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::create
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:36
* @route '/hero-banners/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::create
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:36
* @route '/hero-banners/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::create
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:36
* @route '/hero-banners/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::create
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:36
* @route '/hero-banners/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::create
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:36
* @route '/hero-banners/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::create
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:36
* @route '/hero-banners/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::store
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:41
* @route '/hero-banners'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/hero-banners',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::store
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:41
* @route '/hero-banners'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::store
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:41
* @route '/hero-banners'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::store
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:41
* @route '/hero-banners'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::store
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:41
* @route '/hero-banners'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::edit
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:50
* @route '/hero-banners/{heroSlide}/edit'
*/
export const edit = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/hero-banners/{heroSlide}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::edit
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:50
* @route '/hero-banners/{heroSlide}/edit'
*/
edit.url = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { heroSlide: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { heroSlide: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            heroSlide: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        heroSlide: typeof args.heroSlide === 'object'
        ? args.heroSlide.id
        : args.heroSlide,
    }

    return edit.definition.url
            .replace('{heroSlide}', parsedArgs.heroSlide.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::edit
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:50
* @route '/hero-banners/{heroSlide}/edit'
*/
edit.get = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::edit
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:50
* @route '/hero-banners/{heroSlide}/edit'
*/
edit.head = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::edit
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:50
* @route '/hero-banners/{heroSlide}/edit'
*/
const editForm = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::edit
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:50
* @route '/hero-banners/{heroSlide}/edit'
*/
editForm.get = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::edit
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:50
* @route '/hero-banners/{heroSlide}/edit'
*/
editForm.head = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::update
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:57
* @route '/hero-banners/{heroSlide}'
*/
export const update = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/hero-banners/{heroSlide}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::update
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:57
* @route '/hero-banners/{heroSlide}'
*/
update.url = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { heroSlide: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { heroSlide: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            heroSlide: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        heroSlide: typeof args.heroSlide === 'object'
        ? args.heroSlide.id
        : args.heroSlide,
    }

    return update.definition.url
            .replace('{heroSlide}', parsedArgs.heroSlide.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::update
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:57
* @route '/hero-banners/{heroSlide}'
*/
update.put = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::update
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:57
* @route '/hero-banners/{heroSlide}'
*/
const updateForm = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::update
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:57
* @route '/hero-banners/{heroSlide}'
*/
updateForm.put = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::toggle
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:66
* @route '/hero-banners/{heroSlide}/toggle'
*/
export const toggle = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: toggle.url(args, options),
    method: 'patch',
})

toggle.definition = {
    methods: ["patch"],
    url: '/hero-banners/{heroSlide}/toggle',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::toggle
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:66
* @route '/hero-banners/{heroSlide}/toggle'
*/
toggle.url = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { heroSlide: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { heroSlide: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            heroSlide: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        heroSlide: typeof args.heroSlide === 'object'
        ? args.heroSlide.id
        : args.heroSlide,
    }

    return toggle.definition.url
            .replace('{heroSlide}', parsedArgs.heroSlide.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::toggle
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:66
* @route '/hero-banners/{heroSlide}/toggle'
*/
toggle.patch = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: toggle.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::toggle
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:66
* @route '/hero-banners/{heroSlide}/toggle'
*/
const toggleForm = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggle.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::toggle
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:66
* @route '/hero-banners/{heroSlide}/toggle'
*/
toggleForm.patch = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: toggle.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

toggle.form = toggleForm

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::move
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:73
* @route '/hero-banners/{heroSlide}/move'
*/
export const move = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: move.url(args, options),
    method: 'patch',
})

move.definition = {
    methods: ["patch"],
    url: '/hero-banners/{heroSlide}/move',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::move
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:73
* @route '/hero-banners/{heroSlide}/move'
*/
move.url = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { heroSlide: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { heroSlide: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            heroSlide: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        heroSlide: typeof args.heroSlide === 'object'
        ? args.heroSlide.id
        : args.heroSlide,
    }

    return move.definition.url
            .replace('{heroSlide}', parsedArgs.heroSlide.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::move
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:73
* @route '/hero-banners/{heroSlide}/move'
*/
move.patch = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: move.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::move
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:73
* @route '/hero-banners/{heroSlide}/move'
*/
const moveForm = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: move.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::move
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:73
* @route '/hero-banners/{heroSlide}/move'
*/
moveForm.patch = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: move.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

move.form = moveForm

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::duplicate
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:82
* @route '/hero-banners/{heroSlide}/duplicate'
*/
export const duplicate = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: duplicate.url(args, options),
    method: 'post',
})

duplicate.definition = {
    methods: ["post"],
    url: '/hero-banners/{heroSlide}/duplicate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::duplicate
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:82
* @route '/hero-banners/{heroSlide}/duplicate'
*/
duplicate.url = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { heroSlide: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { heroSlide: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            heroSlide: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        heroSlide: typeof args.heroSlide === 'object'
        ? args.heroSlide.id
        : args.heroSlide,
    }

    return duplicate.definition.url
            .replace('{heroSlide}', parsedArgs.heroSlide.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::duplicate
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:82
* @route '/hero-banners/{heroSlide}/duplicate'
*/
duplicate.post = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: duplicate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::duplicate
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:82
* @route '/hero-banners/{heroSlide}/duplicate'
*/
const duplicateForm = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: duplicate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::duplicate
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:82
* @route '/hero-banners/{heroSlide}/duplicate'
*/
duplicateForm.post = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: duplicate.url(args, options),
    method: 'post',
})

duplicate.form = duplicateForm

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::destroy
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:89
* @route '/hero-banners/{heroSlide}'
*/
export const destroy = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/hero-banners/{heroSlide}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::destroy
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:89
* @route '/hero-banners/{heroSlide}'
*/
destroy.url = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { heroSlide: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { heroSlide: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            heroSlide: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        heroSlide: typeof args.heroSlide === 'object'
        ? args.heroSlide.id
        : args.heroSlide,
    }

    return destroy.definition.url
            .replace('{heroSlide}', parsedArgs.heroSlide.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::destroy
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:89
* @route '/hero-banners/{heroSlide}'
*/
destroy.delete = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::destroy
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:89
* @route '/hero-banners/{heroSlide}'
*/
const destroyForm = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::destroy
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:89
* @route '/hero-banners/{heroSlide}'
*/
destroyForm.delete = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::restore
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:96
* @route '/hero-banners/{heroSlide}/restore'
*/
export const restore = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: restore.url(args, options),
    method: 'patch',
})

restore.definition = {
    methods: ["patch"],
    url: '/hero-banners/{heroSlide}/restore',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::restore
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:96
* @route '/hero-banners/{heroSlide}/restore'
*/
restore.url = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { heroSlide: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { heroSlide: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            heroSlide: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        heroSlide: typeof args.heroSlide === 'object'
        ? args.heroSlide.id
        : args.heroSlide,
    }

    return restore.definition.url
            .replace('{heroSlide}', parsedArgs.heroSlide.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::restore
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:96
* @route '/hero-banners/{heroSlide}/restore'
*/
restore.patch = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: restore.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::restore
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:96
* @route '/hero-banners/{heroSlide}/restore'
*/
const restoreForm = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: restore.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\HeroBanners\HeroBannerController::restore
* @see app/Http/Controllers/Admin/HeroBanners/HeroBannerController.php:96
* @route '/hero-banners/{heroSlide}/restore'
*/
restoreForm.patch = (args: { heroSlide: string | { id: string } } | [heroSlide: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: restore.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

restore.form = restoreForm

const heroBanners = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    toggle: Object.assign(toggle, toggle),
    move: Object.assign(move, move),
    duplicate: Object.assign(duplicate, duplicate),
    destroy: Object.assign(destroy, destroy),
    restore: Object.assign(restore, restore),
}

export default heroBanners